import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68de1f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ie-pool" }
const _hoisted_2 = ["onUpdate:modelValue", "onChange"]
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  class: "stepper-combo"
}
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"display":"flex","justify-content":"space-between","width":"100%","margin-top":"15px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSpinner = _resolveComponent("VueSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h3", {
      class: _normalizeClass(_ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light')
    }, " IE " + _toDisplayString(_ctx.service?.service?.index) + " Infrastructure elements pool ", 3),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ieList, (ie, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "ie",
          key: ie
        }, [
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("select", {
              class: _normalizeClass(["stepper-input", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
              "onUpdate:modelValue": ($event: any) => ((ie.domain) = $event),
              onChange: ($event: any) => (_ctx.fetchIE(ie)),
              name: "domain",
              id: "domain"
            }, [
              _createElementVNode("option", {
                style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                value: null
              }, "Select a domain", 4),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.domains.domains, (domain) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: domain.id,
                  style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                  value: domain.id
                }, _toDisplayString(domain.description), 13, _hoisted_3))
              }), 128))
            ], 42, _hoisted_2), [
              [_vModelSelect, ie.domain]
            ])
          ]),
          _createElementVNode("div", null, [
            (ie.fetching && ie.domain)
              ? (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["loader-placeholer", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
                  key: ie.fetching
                }, [
                  _createVNode(_component_VueSpinner, { color: "#004AAD" })
                ], 2))
              : _createCommentVNode("", true),
            (!ie.fetching && ie.domain)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("select", {
                    class: _normalizeClass(["stepper-input", _ctx.settingsStore.colorScheme === 'dark' ? 'dark' : 'light']),
                    "onUpdate:modelValue": ($event: any) => ((ie.ie) = $event),
                    name: "ie",
                    id: "ie"
                  }, [
                    _createElementVNode("option", {
                      style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                      value: null
                    }, "Select a IE", 4),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ie.availableIes, (d) => {
                      return _withDirectives((_openBlock(), _createElementBlock("option", {
                        key: d,
                        style: _normalizeStyle({
                'color': _ctx.settingsStore.colorScheme === 'dark' ? '#ffffff' : '#282828',
                'background-color':  _ctx.settingsStore.colorScheme === 'dark' ? '#282828' : '#ffffff'
                }),
                        value: d.id
                      }, _toDisplayString(d?.hostname), 13, _hoisted_6)), [
                        [_vShow, !_ctx.ieList.some((item, i) => item.ie === d.id) && !ie.ie]
                      ])
                    }), 128))
                  ], 10, _hoisted_5), [
                    [_vModelSelect, ie.ie]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("a", {
            class: "remove",
            onClick: ($event: any) => (_ctx.removeIE(index))
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "trash" })
          ], 8, _hoisted_7)
        ]))
      }), 128)),
      _createElementVNode("button", {
        class: "stepper-btn",
        style: {"justify-self":"center"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addIE()))
      }, "Add IE")
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('back'))),
        class: "confirm"
      }, "Back"),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm', {data: _ctx.ieList.map((ie) => {return {ie: ie.ie, domain: ie.domain}}), index: _ctx.service?.service, field: 'iePool'}))),
        class: "cancel"
      }, "Save")
    ])
  ], 64))
}